import { Button } from '@mantine/core';
import { IconUserOff } from '@tabler/icons-react';

interface NoTenantsFilterProps {
    /** Whether the filter is active (only rows with zero linked tenants are listed). */
    value: boolean;
    /** Fired with the new state when the toggle is pressed. */
    onChange: (value: boolean) => void;
}

/**
 * Toggle that narrows a catalog grid to rows with no linked tenants
 * (`tenant_count = 0`), so reviewers can find unused entries and purge them.
 * Drives a SERVER-SIDE filter; sits beside the provider filter.
 */
export function NoTenantsFilter({ value, onChange }: NoTenantsFilterProps): React.JSX.Element {
    return (
        <Button
            variant={value ? 'light' : 'default'}
            leftSection={<IconUserOff size={16} stroke={1.5} />}
            aria-pressed={value}
            onClick={() => {
                onChange(!value);
            }}
            data-testid="NoTenantsFilterButton"
        >
            No tenants
        </Button>
    );
}
